import { AutogenLayoutlayout_dimuident } from "./autogen/AutogenLayoutlayout_dimuident";
import {  TableRowDisplayEvent } from "@mcleod/components";

export class layout_dimuident extends AutogenLayoutlayout_dimuident {

/** This is an event handler for the onRowDisplay event of tblDimuIdentifiers. */
  tblDimuIdentifiersOnRowDisplay(event: TableRowDisplayEvent) {
    //do nothing
  }
}
